import { Box, Typography } from '@mui/material'
import { SliderNunaKey } from 'assets'
import { LandingButton, Navbar, NunaLabel } from 'components'
import { COLORS } from 'const'
import { motion } from 'framer-motion'
import { useDataLanding } from 'hooks'
import {
  containerVariants,
  landingButtonPrimary,
  ROLL_SLIDER,
  sliderContainer,
  sliderContentContainer,
  sliderMainTitle,
  sliderNavbarContainer,
  sliderTextContainer,
} from 'styles'

export const SliderSection = () => {
  const { content } = useDataLanding()

  return (
    <Box
      sx={{
        ...sliderContainer,
        backgroundImage: `url(${SliderNunaKey})`,
      }}
    >
      <Box sx={sliderNavbarContainer}>
        <Navbar />
      </Box>

      <Box sx={sliderContentContainer}>
        <Box
          sx={sliderTextContainer}
          component={motion.div}
          initial="offscreen"
          whileInView="onscreen"
          variants={containerVariants}
          viewport={{ once: true }}
        >
          <NunaLabel sxTextProps={{ fontSize: 72 }} sxImgProps={{ width: 72, height: 72 }} />

          <Typography variant="h2" sx={sliderMainTitle}>
            {content?.slider?.mainTitle}
          </Typography>

          <Box
            pb={{ xs: 0, md: 2, lg: 4, xl: 6 }}
            sx={{
              display: { xs: 'flex', md: 'inline-block' },
              justifyContent: { xs: 'center' },
              width: '100%',
              textAlign: 'left',
              height: '36px',
              '& > div': {
                opacity: 0,
                position: 'absolute',
              },
              '& > div:nth-of-type(1)': {
                animation: `${ROLL_SLIDER} 16s linear infinite 0s`,
              },
              '& > div:nth-of-type(2)': {
                animation: `${ROLL_SLIDER} 16s linear infinite 4s`,
              },
              '& > div:nth-of-type(3)': {
                animation: `${ROLL_SLIDER} 16s linear infinite 8s`,
              },
              '& > div:nth-of-type(4)': {
                animation: `${ROLL_SLIDER} 16s linear infinite 12s`,
              },
            }}
          >
            {content?.slider?.subDescription?.map((text, index) => (
              <Box key={index}>
                <Typography
                  component="span"
                  sx={{
                    ...sliderMainTitle,
                    color: '#C5E04C',
                  }}
                >
                  {text}
                </Typography>
              </Box>
            ))}
          </Box>

          <LandingButton
            text={content?.slider?.buttonText || 'COMIENZA AHORA'}
            style={{
              ...landingButtonPrimary,
              backgroundColor: COLORS.button.second,
              borderRadius: '30px',
              mt: 2,
              px: {
                xs: 3,
                md: 4,
              },
              width: 'fit-content',
            }}
            onClick={() => {
              window.open(
                process.env.REACT_APP_NUNA_PROCESS_ONBOARDING ?? content?.slider?.buttonLink,
                '_blank'
              )
            }}
          />
        </Box>
      </Box>
    </Box>
  )
}
